import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/pages/HomePage.vue';
import ServicesPage from '@/pages/ServicesPage.vue';
import ContactPage from '@/pages/ContactPage.vue';
import Healthcare from '@/pages/HealthCare';
import FinancialServices from '@/pages/FinancialServices.vue';
import Logistics from '@/pages/LogisticsPage.vue';
import Insurance from '@/pages/InsurancePage.vue';
import IndustryPage from '@/pages/IndustryPage.vue';
// import AI_ML from '@/pages/AI_ML.vue';
// import Data from '@/pages/Data_Page.vue';
// import ETL_ELT from '@/pages/ETL_ELT.vue';
// import API_Led from '@/pages/API_Led.vue';
// import Microservices from '@/pages/MicroservicesPage.vue';
// import EnterpriseArchitecture from '@/pages/EnterpriseArchitecture.vue';
// import ServiceDetails from '@/components/ServiceDetails.vue';


const routes = [
    { path: '/', component: HomePage },
    { path: '/services', component: ServicesPage },
    { path: '/contact', component: ContactPage },
    { path: '/industries', component: IndustryPage },
    { path: '/pages/healthcare', component: Healthcare },
    { path: '/pages/financial-services', component: FinancialServices },
    { path: '/pages/logistics', component: Logistics },
    { path: '/pages/insurance', component: Insurance },
    // { path: '/ai-ml', component: AI_ML },
    // { path: '/data', component: Data },
    // { path: '/etl-elt', component: ETL_ELT },
    // { path: '/api-led', component: API_Led },
    // { path: '/microservices', component: Microservices },
    // { path: '/enterprise-architecture', component: EnterpriseArchitecture },
    // { path: '/services/:serviceKey', component: ServiceDetails, props: true }


];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
